module.exports = __webpack_public_path__ + "img/azall.c6ea4103.png";